export default {"src":"/_next/static/image/public/images/ic_video_mic.59fc21512a964a038c9225af2196d4ac.svg","height":56,"width":56};